import { useState, useCallback } from 'react';
import { googlefonts as api } from '../api/client.js';

export function useGoogleFonts() {
  const [fonts, setFonts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(null);

  const search = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await api.list(params);
      setFonts(result.fonts || []);
      setTotal(result.total || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const importFont = useCallback(async (fontData) => {
    try {
      const result = await api.import(fontData);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  }, []);

  return { fonts, total, loading, error, search, importFont };
}
